; (function (window, document, $, application) {
    var cookieBarService = {
        url: '/cookiebar/',
        acceptTerms: function () {
            var methodUrl = this.url + 'acceptTerms';

            return $.post(methodUrl);
        }
    };

    application.services = application.services || {};
    application.services.cookieBarService = cookieBarService;
})(window, document, $, application = window.application || {});

; (function (window, document, cookieBarService) {
    'use strict';

    if (!cookieBarService) {
        return;
    }

    function onAcceptingTerms(e) {
        e.preventDefault();

        cookieBarService.acceptTerms();
        $('[data-ui-component="cookie-bar"]').remove();
    }

    $('[data-accept-cookies]').one('click', onAcceptingTerms);
})(window, document, application.services.cookieBarService);